<template>
  <div class="destCard" v-on="$listeners">
    <transition name="fade-in">
      <div class="content" v-if="!isLoading">
        <div class="img">
          <img :src="img" alt="" />
          <div class="dates">{{ dates }}</div>
          <div class="theme">{{ name }}</div>
        </div>
        <div class="info preferences">
          <div class="top-label left">Preferences</div>

          <div class="bottom-label left">
            <strong>{{ prefNumber }}</strong> Preferences
          </div>
        </div>
        <div class="info hotel">
          <div class="top-label left">Itinerary</div>
          <div class="bottom-label left">
            <strong>{{ placesNumber }}</strong> Places
          </div>
        </div>
        <div class="info action">
          <div class="text">View Trip</div>
          <div class="right price">
            <div class="usd" v-if="fullPrice.usd">{{ fullPrice.usd }}</div>
            <div class="points" v-if="fullPrice.points">{{ fullPrice.points }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {formatPrices, getReadableDuration} from '@mobi-components/amex-bluesky-components';

export default {
  name: 'AmexMyTripsCard',
  props: {
    trip: {
      type: Object,
      default: () => null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatPrice(prices) {
      const cost = formatPrices(prices, 'Points', 0);
      const usd = cost.labels['USD'];
      const usdValue = cost.values['USD'] || 0;
      const points = cost.values['AMEX_POINT'] || 0;
      const shortPoints =
        points / 1000 > 1
          ? `${usdValue ? '+' : ''}${Math.floor(points / 1000)}k Points`
          : cost.labels['AMEX_POINT'] || '';
      return {usd, points: shortPoints};
    },
  },
  computed: {
    img() {
      return (this.trip && this.trip.images && this.trip.images.length && this.trip.images[0]) || '';
    },
    name() {
      return (this.trip && this.trip.name) || '';
    },
    dates() {
      const start = (this.trip && this.trip.scheduled_start_time) || null;
      const end = (this.trip && this.trip.scheduled_end_time) || null;

      if (!start || !end) {
        return '';
      }
      const startDate = new Date(start * 1000);
      const endDate = new Date(end * 1000);
      return getReadableDuration(startDate, endDate);
    },
    prefNumber() {
      return this.trip && this.trip.prefs.length;
    },
    placesNumber() {
      return this.trip && this.trip.places;
    },
    fullPrice() {
      const prices = (this.trip && this.trip.prices) || [];
      return this.formatPrice(prices);
    },
  },
};
</script>

<style lang="scss" scoped>
.destCard {
  border-radius: var(--card-br, 20px);
  background-color: #f7f7f7;
  color: #fff;
  width: 100%;
  // height: 0px;
  // padding-top: 100%;
  padding-left: 0;
  overflow: hidden;
  position: relative;
  display: block;
  border: none;
  appearance: none;
  text-align: left;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  max-width: 350px;
}
.destCard:hover {
  cursor: pointer;
}
.destCard img {
  top: 0;
  width: 100%;
  height: 120px;
  object-fit: cover;
}
.destCard:hover::before {
  background-color: rgba(7, 29, 59, 0.4);
  height: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.img {
  flex: 1 1 auto;
  position: relative;
}

.info {
  background-repeat: no-repeat;
  padding-left: 40px;
  position: relative;
  background-position: 14px;
  background-size: 14px;
  padding: 10px 14px 10px 40px;
}

.info + .info {
  border-top: 1px solid #f1f1f1;
}

.info.preferences {
  background-image: url("data:image/svg+xml,%3Csvg width='22' height='12' viewBox='0 0 22 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' width='11.25' height='5.25' rx='2.57143' fill='%23A3ABB6'/%3E%3Crect x='14' width='7.5' height='5.25' rx='2.57143' fill='%23A3ABB6'/%3E%3Crect x='6.5' y='6.75' width='11.25' height='5.25' rx='2.57143' fill='%23A3ABB6'/%3E%3C/svg%3E%0A");
}
.info.hotel {
  background-image: url("data:image/svg+xml,%3Csvg width='21' height='24' viewBox='0 0 21 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 6.53125V10.3125C11 10.4948 10.9276 10.6697 10.7986 10.7986C10.6697 10.9276 10.4948 11 10.3125 11H9.625C9.44266 11 9.2678 10.9276 9.13886 10.7986C9.00993 10.6697 8.9375 10.4948 8.9375 10.3125V9.625H2.0625V10.3125C2.0625 10.4948 1.99007 10.6697 1.86114 10.7986C1.7322 10.9276 1.55734 11 1.375 11H0.6875C0.505164 11 0.330295 10.9276 0.201364 10.7986C0.0724328 10.6697 0 10.4948 0 10.3125V6.53125C0 6.34891 0.0724328 6.17405 0.201364 6.04511C0.330295 5.91618 0.505164 5.84375 0.6875 5.84375H10.3125C10.4948 5.84375 10.6697 5.91618 10.7986 6.04511C10.9276 6.17405 11 6.34891 11 6.53125ZM8.25 0H2.75C2.56766 0 2.3928 0.0724328 2.26386 0.201364C2.13493 0.330295 2.0625 0.505164 2.0625 0.6875V1.375H1.375C1.19266 1.375 1.0178 1.44743 0.888864 1.57636C0.759933 1.7053 0.6875 1.88016 0.6875 2.0625V4.8125H2.0625V4.46875C2.0625 4.19525 2.17115 3.93294 2.36455 3.73955C2.55794 3.54615 2.82025 3.4375 3.09375 3.4375H3.78125C4.05475 3.4375 4.31706 3.54615 4.51045 3.73955C4.70385 3.93294 4.8125 4.19525 4.8125 4.46875V4.8125H6.1875V4.46875C6.1875 4.19525 6.29615 3.93294 6.48955 3.73955C6.68294 3.54615 6.94525 3.4375 7.21875 3.4375H7.90625C8.04168 3.4375 8.17578 3.46417 8.30089 3.516C8.42601 3.56782 8.53969 3.64379 8.63545 3.73955C8.73121 3.83531 8.80718 3.94899 8.859 4.07411C8.91083 4.19922 8.9375 4.33332 8.9375 4.46875V4.8125H10.3125V2.0625C10.3125 1.88016 10.2401 1.7053 10.1111 1.57636C9.9822 1.44743 9.80734 1.375 9.625 1.375H8.9375V0.6875C8.9375 0.505164 8.86507 0.330295 8.73614 0.201364C8.6072 0.0724328 8.43234 0 8.25 0Z' fill='%23A3ABB6'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.9662 15.1025C21.3985 19.6897 17.5559 23.2383 16.5792 24C14.3376 22.269 12 18.9454 12 15.8642C12 13.1638 14.0174 11 16.4991 11C18.7407 11 20.598 12.783 20.9502 15.1025H20.9662ZM16.4991 13.0253C17.732 13.0253 18.7407 14.1158 18.7407 15.4487C18.7407 16.7816 17.732 17.8549 16.4991 17.8549C15.2663 17.8549 14.2736 16.7643 14.2736 15.4487C14.2736 14.1158 15.2823 13.0253 16.4991 13.0253Z' fill='%23A3ABB6'/%3E%3C/svg%3E%0A");
}
.info.action {
  background: #071d3b;
}
.info.action {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  align-items: center;
}
.info.action .text {
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 118.14%;
  letter-spacing: 0.195em;
  color: #ffffff;
  text-transform: uppercase;
  white-space: nowrap;
}

.top-label {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: rgba(7, 29, 59, 0.37);
}

.top-label.right {
  right: 14px;
  left: auto;
}

.bottom-label {
  display: inline-block;
  white-space: nowrap;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #071d3b;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bottom-label + .bottom-label {
  margin-left: 10px;
  flex: 0 0 auto;
}

.bottom-label.left + .bottom-label.left {
  display: none;
}

.price {
  display: flex;
  white-space: nowrap;
  overflow: visible;
  padding-left: 25px;
}
.price > .usd,
.price > .points {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 118.14%;
  text-align: right;
  letter-spacing: -0.005em;
  color: #071d3b;
}
.price > .points {
  margin-left: 2px;
  color: var(--primary-color, hsl(208, 100%, 41%));
  font-weight: 700;
  position: absolute;
  font-size: 12px;
  top: -7px;
  right: 0;
}

.price > .usd + .points {
  top: 16px;
}

.action .price > .usd {
  color: #fff;
  font-weight: 700;
}
.action .price .points {
  position: relative;
  top: auto;
  margin-top: 2px;
}

.dates {
  font-style: normal;
  font-weight: 400;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #ffffff;
  position: absolute;
  bottom: 20px;
  z-index: 1;
  bottom: 30px;
  left: 15px;
  max-width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1;
  font-size: 12px;
  opacity: 0.7;
}

.theme {
  font-style: normal;
  font-weight: 700;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #ffffff;
  position: absolute;
  left: 15px;
  max-width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1;
  bottom: 10px;
  font-size: 18px;
}

.light {
  opacity: 0.6;
}
</style>
